module.exports = __webpack_public_path__ + "img/paymentmethods.be78fe94.svg";